module.exports = __webpack_public_path__ + "static/media/galleryImg21.f5885907.jpg";